import salesrep from './salesrep';
import product from "./product";
import order from "./order";
import accountRecords from "./account-records";
import irDetails from './IR-details';
import support from './support';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    {
      id: 'main-nav',
      title: '',
      type: 'group',
      children: [
        product.children[0],          // Catalog
        accountRecords.children[0],   // Accounts
        order.children[0],            // Cart
        order.children[1],            // Orders
        product.children[3],          // Bulk Price Update
        product.children[1],          // Shopping List
        salesrep.children[2],         // Inside Sales Dashboard
        salesrep.children[3],         // Business Dashboard
        salesrep.children[0],         // Sales Dashboard
        support.children[0],          // Support Ticket
        salesrep.children[1],         // Ops Dashboard
        product.children[2],          // Bulk Uploads
        irDetails.children[0],        // IR Management
        accountRecords.children[1],   // Account Records
      ]
    }
  ]
};

export default menuItems;
